import React, { useMemo } from 'react'
import { SINGLE_TYPE_AMOUNT } from './constants'
import MixedAbsenceDates from './timeline-absence-dates-content/mixed-absence-date-types'
import SimpleAbsenceDates from './timeline-absence-dates-content/simple-absence-dates'
import type { TimelineAbsenceDatesProps } from './types'

const TimelineAbsenceDates: React.FC<TimelineAbsenceDatesProps> = ({ dates, dateFrom, dateTo }) => {
  const isMultiDay = useMemo(() => dateFrom !== dateTo, [dateFrom, dateTo])
  const isMultiType = useMemo(() => {
    if (!isMultiDay) return true

    const typesWithoutDupes = dates
      .map((date) => date.type)
      .filter((type, index, array) => {
        return array.indexOf(type) === index
      })

    return typesWithoutDupes.length > SINGLE_TYPE_AMOUNT
  }, [dates, isMultiDay])

  if (isMultiDay && isMultiType) {
    return <MixedAbsenceDates dates={dates} dateFrom={dateFrom} dateTo={dateTo} />
  }

  return <SimpleAbsenceDates dates={dates} dateFrom={dateFrom} dateTo={dateTo} />
}

export default TimelineAbsenceDates
